// Create types for the column structure
export interface Column {
  name: string
  title: string
  description: string
  subcolumns?: Column[]
  data_type?: string
}
export type ExportType = 'orders' | 'all_checkouts' | 'abandoned_checkouts' | 'today' | 'refunds'

export const ExportTypeValues: ExportType[] = ['orders', 'all_checkouts', 'abandoned_checkouts', 'today', 'refunds']

export type ExportFrequency = 'once' | 'recurring'
export interface ExportConfigStep1 {
  exportType: ExportType
  selectedColumns: ReadonlyArray<string>
}

export interface Schedule {
  frequency: 'daily' | 'weekly' | 'monthly' | 'hourly'
  hour: number
  day?: number
  cronExpression: string
  scheduledStartDate: string
}

export interface DownloadReportConfig {
  step1: ExportConfigStep1
  step2: ExportConfigStep2
}

export interface ExportConfigStep2 {
  exportFrequency: 'once' | 'recurring'
  dateRange: {
    startDate: string
    endDate: string
  }
  schedule?: Schedule
  email?: string
  emails: string[]
  reportName: string
}

export enum ExportStep {
  SELECT_COLUMNS = 'SELECT_COLUMNS',
  CONFIGURE_EXPORT = 'CONFIGURE_EXPORT'
}
